import { render, staticRenderFns } from "./TenderInformation.vue?vue&type=template&id=0085d90b&scoped=true"
import script from "./TenderInformation.vue?vue&type=script&lang=js"
export * from "./TenderInformation.vue?vue&type=script&lang=js"
import style0 from "./TenderInformation.vue?vue&type=style&index=0&id=0085d90b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085d90b",
  null
  
)

export default component.exports